import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as l, normalizeClass as d, createElementVNode as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconQuickReply",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  d: "M10 7.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 1 1 0-1h5A1.5 1.5 0 0 1 11 2.5v5A1.5 1.5 0 0 1 9.5 9H3.707l-1.853 1.853A.5.5 0 0 1 1 10.5V8a.5.5 0 0 1 1 0v1.293l1.147-1.147.076-.062A.5.5 0 0 1 3.5 8h6a.5.5 0 0 0 .5-.5ZM2.071.743a.5.5 0 0 1 .858.514L1.883 3H3l.066.005a.5.5 0 0 1 .393.692l-.03.06-1.5 2.5a.5.5 0 0 1-.858-.514L2.117 4H1a.501.501 0 0 1-.429-.757l1.5-2.5Z",
  fill: "currentColor"
}, null, -1), u = [
  _
];
function m(e, h, i, p, f, a) {
  return l(), r("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--quick-reply"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Quick Reply",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, u, 10, c);
}
const k = /* @__PURE__ */ s(o, [["render", m]]);
export {
  k as default
};
//# sourceMappingURL=quick-reply.js.map
